/* eslint-disable @typescript-eslint/ban-ts-comment */

import { AppEnv } from './AppEnv';

export function getMainEnv(): AppEnv | undefined {
  if (typeof import.meta.env !== 'undefined') {
    return import.meta.env;
  }

  return undefined;
}
